/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { colors } from "./colors";

const typeMarkerWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: 1px solid ${colors.greyBorder};
  border-radius: 9999px;
`;

type Props = {
  backgroundColor: string;
};

export const StatusIndicator = ({ backgroundColor }: Props) => {
  const statusIndicatorStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 6px;
    min-height: 6px;
    width: 6px;
    min-width: 6px;
    border-radius: 9999px;
    background-color: ${backgroundColor};
  `;

  return (
    <div css={typeMarkerWrapperStyle}>
      <div css={statusIndicatorStyle} />
    </div>
  );
};
